import React from 'react'

import MainSectionLayout from '@/main-section-layout'
import PageTopBar from '@/page-top-bar'
import GetStartedPackage from '@/get-started-package'

import './styles.css'

const SectionGetStartedPackage = () => {
  return (
    <PageTopBar iconName="handshakes" text="Business Model">
      <MainSectionLayout
        title="Business Model"
        about="Our business model is simple"
      >

        <div className="flex flex-wrap">
          <GetStartedPackage free mainColor="#cb9f3f" />
          <GetStartedPackage custom mainColor="#000" />
        </div>
      </MainSectionLayout>
    </PageTopBar>
  )
}

export default SectionGetStartedPackage



// WEBPACK FOOTER //
// ./src/components/section-business-model/section-business-model.js